import axios from "axios";

class AuthService {
  static async convertToken(twoFactorJWT) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/convert-token`,
        {},
        {
          headers: {
            Authorization: `Bearer ${twoFactorJWT}`,
          },
        }
      );

      if (!response.data?.jwt) {
        throw new Error("No JWT received from server");
      }

      return response.data.jwt;
    } catch (error) {
      console.error("Token conversion failed:", error);
      if (error.response?.status === 401) {
        throw new Error("Authentication failed: Invalid token");
      }
      throw error;
    }
  }

  static async handleAuthentication(responseData, navigate) {
    try {
      if (!responseData?.jwt) {
        throw new Error("No JWT token received from initial authentication");
      }

      // Store initial JWT
      const strapiJWT = await this.convertToken(responseData.jwt);

      // Store the final JWT
      localStorage.setItem("jwt", strapiJWT);

      // Configure axios defaults for future requests
      axios.defaults.headers.common["Authorization"] = `Bearer ${strapiJWT}`;

      navigate("/");
    } catch (error) {
      console.error("Authentication failed:", error);
      throw new Error(error.message || "Authentication failed");
    }
  }

  static async login(credentials) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/login-2fa`,
        credentials
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Login failed");
    }
  }
}

export default AuthService;
